module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.bcc70be7.png";